module.exports = __webpack_public_path__ + "img/BlogPost.ea33bf02.jpg";